import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { FormattedMessage } from 'react-intl';

import { Pluggable } from '@folio/stripes/core';

const InventoryDefaultFieldsSettings = ({ match }) => {
  return (
    <Pluggable
      type="inventory-templates"
      basePath={match.path}
      redirectTo="default-fields-list"
    >
      <FormattedMessage id="ui-inventory.templatesPluginNotAvailable" />
    </Pluggable>
  );
};

InventoryDefaultFieldsSettings.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default InventoryDefaultFieldsSettings;
